<template>
  <v-card
    class="invoice-parameter-card d-flex flex-column">
    <v-container fluid fill-height class="flex-grow-1">
      <v-row
        class="d-flex align-stretch">
        <SelectionStepFlow />
        <v-col
          class="d-flex align-center"
          cols="1">
          <span
            v-if="inLevelSelectionStep"
            class="text-decoration-underline primary--text ui-text-base"
            style="cursor: pointer;"
            @click="cleanEntities">
            Limpar campos
          </span>
        </v-col>
        <v-col
          class="d-flex align-center justify-end"
          cols="1">
          <v-menu
            absolute
            :position-x="menuX"
            :position-y="menuY"
            open-on-hover
            transition="fade-transition"
            color="transparent"
            content-class="invoiceMenu"
            offset-y
            v-model="infoMenu"
          >
            <template
              v-slot:activator="{ on, attrs }">
              <v-icon
                ref="helpIcon"
                v-on="on"
                v-bind="attrs" color="primary">
                fas fa-question-circle
              </v-icon>
            </template>

            <div class="">
              <div class="d-flex flex-row">
                <v-card
                  width="400"
                  class="invoiceInfoCard pa-5 primary--text">
                  <span class="d-block font-weight-bold">
                    Entendendo a Hierarquia de Regras
                  </span>

                  <span class="d-block">
                    As regras seguem uma ordem de prioridade conforme o nível em que são aplicadas. Níveis mais específicos sobrepõem regras mais genéricas automaticamente:
                  </span>

                  <div class="my-2">
                    <span class="d-block">
                      <b>Operadora</b> (mais genérico)
                    </span>
                    <span class="d-block">
                      <b>Grupo Financeiro →</b> sobrepõe regras no nível de Operadora
                    </span>
                    <span class="d-block">
                      <b>Contrato →</b> sobrepõe regras nos níveis de Grupo Financeiro e Operadora
                    </span>
                    <span class="d-block">
                      <b>Subcontrato (mais específico) →</b> sobrepõe regras de todos os níveis anteriores
                    </span>
                  </div>
                    Ao criar uma nova regra, o sistema aplica automaticamente a que estiver no nível mais específico para a mesma combinação de filtros.
                </v-card>
              </div>
            </div>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import SelectionStepFlow from './components/SelectionStepFlow.vue';
import Autocomplete from '../Default/Autocomplete.vue';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'LevelSelectionStep',
  components: {
    SelectionStepFlow,
    Autocomplete,
  },
  data: () => ({
    infoMenu: false,
    menuY: 0,
    menuX: 0,
  }),
  mixins: [
    InvoiceParametersMixin,
  ],
  watch: {
    infoMenu: {
      handler(opened) {
        if (opened) {
          const el = this.$refs.helpIcon && this.$refs.helpIcon.$el;
          if (!el) return false;
          const r = el.getBoundingClientRect();
          this.menuX = r.left - 420;
          this.menuY = r.bottom - 35;
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      cleanEntities: 'invoice-parameter/cleanEntities',
    }),

  },
  computed: {
    ...mapGetters({
      form: 'invoice-parameter/form',
      entities: 'invoice-parameter/entities',
      entityKeys: 'invoice-parameter/entityKeys',
      step: 'invoice-parameter/invoiceParameterStep',
    }),
  }
}
</script>

<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
.invoiceInfoCard {
  position: relative;
  overflow: visible !important;
  background: var(--v-muted-base);
  border-radius: $border-radius-component-value;
}

.invoiceMenu {
  box-shadow: $box-shadow-component-value !important;
}
</style>